<template>
  <v-content class="api-explorer page">
    <can I="read" a="Api">
      <v-container>
        <v-toolbar flat class="transparent">
          <v-breadcrumbs class="pl-0"
            :items="[{ exact: true, text: 'Admin', to: '/dashboard' },
                     { exact: true, text: 'API', to: '/api' }]">
            <v-icon slot="divider">mdi-chevron-right</v-icon>
          </v-breadcrumbs>

          <v-spacer />

          <v-tooltip left>
            <v-btn small flat fab :href="$route.fullPath" slot="activator">
              <v-icon>mdi-link-variant</v-icon>
            </v-btn>
            <span>{{ $route.fullPath }}</span>
          </v-tooltip>
        </v-toolbar>

        <v-card toolbar>
          <v-toolbar flat color="transparent">
            <v-card-title>
              <div class="headline">API Explorer</div>
            </v-card-title>
            <v-spacer />
            <v-btn flat>
              Administrator
              <v-icon right>mdi-account-box</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <div class="title">Request</div>
            <v-toolbar flat color="transparent" class="mx-0 mt-3">
              <v-text-field
                label="Endpoint"
                v-model="path"
                placeholder="Specify an API endpoint"
                @keyup.enter="request"
              />

              <v-menu offset-y>
                <v-btn flat color="primary" slot="activator">
                  {{ this.method }}
                </v-btn>
                <v-list>
                  <v-list-tile @click="method = 'GET'">GET</v-list-tile>
                  <v-list-tile @click="method = 'POST'">POST</v-list-tile>
                  <v-list-tile @click="method = 'PATCH'">PATCH</v-list-tile>
                  <v-list-tile @click="method = 'DELETE'">DELETE</v-list-tile>
                </v-list>
              </v-menu>

              <v-btn
                color="primary"
                :loading="loading"
                @click="request"
              >
                Submit
              </v-btn>

            </v-toolbar>
          </v-card-text>
          <v-divider />
          <v-card-text v-if="response || error">
            <div class="title mb-3">Response</div>
            <pre v-if="error" v-html="error"></pre>
            <pre v-if="response" v-html="response"></pre>
          </v-card-text>
        </v-card>
      </v-container>
    </can>
  </v-content>
</template>

<script>
const endpoints = {
  Administrator: {
    administrators: {
      index: `/admin/administrators`
    }
  },
  Client: {},
  Candidate: {},
  Guest: {}
}

// Vue Component
export default {
  created() {},
  data() {
    return {
      loading: false,
      // Endpoint selection
      path: '/admin',
      method: 'GET',
      // API Response
      response: null,
      error: null,
      // Authorization tokens
      tokens: {
        administrator: this.$auth.getToken(),
        client: null,
        candidate: null
      }
    }
  },
  methods: {
    request() {
      switch (this.method) {
        case 'GET':
          this.loading = true
          this.$http
            .get(this.path)
            .then(response => {
              this.response = response.data
              this.error = null
            })
            .catch(error => {
              this.error = error.message
              this.response = null
            })
            .finally(() => {
              this.loading = false
            })
          break
        default:
          this.$store.commit('snackbar', {
            text: 'Methods other than GET are not yet supported',
            type: 'warning'
          })
      }
    }
  }
}
</script>
